import React from 'react';
import styled from 'styled-components';
import { theme, toRem } from 'design';
import { Text } from '../Typography';

interface InviteCardProps {
  role: string;
  entity?: string;
  className?: string;
}

const Layout = styled.li`
  display: flex;
  flex-grow: 0;
  flex-shrink: 0;
  flex-flow: column nowrap;
  justify-content: center;
  align-items: center;
  width: 100%;
  max-width: ${toRem(275)};
  height: auto;
  min-height: ${toRem(120)};
  margin-bottom: ${toRem(11)};
  padding: ${toRem(22)} ${toRem(22)};
  border: ${toRem(1)} solid ${theme.color.neutral[100]};
  border-radius: ${toRem(11)};
  background-color: ${theme.color.neutral[50]};
  list-style: none;
  text-align: center;

  &:last-child {
    margin-bottom: 0;
  }
`;

const Role = styled.h2`
  font-family: ${theme.font.family.euclid};
  font-weight: ${theme.font.weight.bold};
  font-size: ${toRem(18.75)};
  line-height: 100%;
  color: ${theme.color.neutral[900]};
`;

const Entity = styled(Text).attrs({ size: 'default' })`
  margin-top: ${toRem(8.75)};
  font-weight: ${theme.font.weight.medium};
  line-height: 125%;
  word-break: break-all;
`;

const InviteCard: React.FC<InviteCardProps> = ({ role, entity, className, ...rest }) => (
  <Layout className={className} {...rest}>
    <Role data-cy="role">{role}</Role>
    <Entity data-cy="entity">{entity}</Entity>
  </Layout>
);

export default InviteCard;
